import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Drawer, useTheme, useMediaQuery } from '@mui/material';
import { selectMenuOpened } from 'src/old/actions/menu/menuSelectors';
import { openMenu, closeMenu } from '../../../../old/actions';
import NavbarContent from './NavbarContent';

const useStyles = makeStyles(() => ({
  desktopDrawer: {
    borderRight: 'none',
    transition: 'width 250ms ease-in-out',
    width: ({ collapsed }) => (collapsed ? 95 : 256),
    overflow: 'hidden'
  }
}));

const NavBar = ({ userRole }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('md'));
  const menuOpen = useSelector(selectMenuOpened);
  const classes = useStyles({ collapsed: !menuOpen });

  useEffect(() => {
    if (mobileDevice) {
      dispatch(closeMenu());
    } else {
      dispatch(openMenu());
    }
  }, [mobileDevice]);

  return (
    <Drawer
      anchor="left"
      classes={{
        paper: classes.desktopDrawer
      }}
      open
      variant="persistent"
    >
      <NavbarContent userRole={userRole} menuOpen={menuOpen} classes={classes} />
    </Drawer>
  );
};

NavBar.propTypes = {
  userRole: PropTypes.oneOf(['ADMIN', 'USER'])
};

export default NavBar;
